import { Button } from 'designSystem/components/Button'
import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

/**
 * A row of prompts that the user can send in one click, as shadcn's
 * Suggestion (ui.shadcn.com/docs/ai-elements/radix/suggestion). The row
 * scrolls sideways when the prompts do not fit, and `scroll-fade-x` fades the
 * edge that has more to show. shadcn hides the scrollbar with `scrollbar-none`,
 * which this Tailwind version does not have; `scrollbar-hide` (index.css) does
 * the same.
 */
function Suggestions({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='suggestions'
      className={cn(
        'flex scroll-fade-x scrollbar-hide gap-2 overflow-x-auto overscroll-x-contain',
        className
      )}
      {...props}
    />
  )
}

/**
 * One prompt: an outline Button whose label is the prompt. `onClick` gets the
 * prompt, so the caller can send it as it is. `shrink-0` keeps the label on
 * one line.
 */
function Suggestion({
  suggestion,
  onClick,
  className,
  children,
  ...props
}: Omit<React.ComponentProps<typeof Button>, 'onClick'> & {
  suggestion: string
  onClick?: (suggestion: string) => void
}) {
  return (
    <Button
      data-slot='suggestion'
      type='button'
      variant='outline'
      size='sm'
      className={cn('shrink-0', className)}
      onClick={() => onClick?.(suggestion)}
      {...props}>
      {children ?? suggestion}
    </Button>
  )
}

export { Suggestion, Suggestions }
